export default __webpack_public_path__ + "static/together-6b0c2ab75a1d5712dbf3ac12eac8adad.webp";